///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { NgModule } from '@angular/core';
import { UserService } from '../service/user.service';
import { usersListFeatureKey } from './users-list.state';
import { reducer } from './users-list.reducers';
import { UsersListEffects } from './effects/users-list.effects';
import { UserChangesEffects } from './effects/user-changes.effects';
import { GtthUserActivityService } from '../../system-reports/user-activity-overview/user-activity.service';
import { AuditsService } from '../../system-reports/audits/service/audits.service';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        StoreModule.forFeature(usersListFeatureKey, reducer),
        EffectsModule.forFeature([UsersListEffects, UserChangesEffects])
    ],
    providers: [UserService, GtthUserActivityService, AuditsService]
})
export class UsersListStoreModule {}
